export const KeepTypes = [
  Object.freeze({ id: "ReportTask", name: "ReportTask" }),
];
